import { api } from './client';

export function login({ email, password }) {
  return api.post('/auth/login', { email, password }, { auth: false });
}

export function register({ email, password, name, whatsappNumber }) {
  return api.post('/auth/register', { email, password, name, whatsappNumber }, { auth: false });
}

export function getMe() {
  return api.get('/establishments/me');
}

export function updateMe(data) {
  return api.patch('/establishments/me', data);
}
